import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

export default function EntitlementLines({ entitlementLines }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="Entitlement Lines">
        <TableHead>
          <TableRow>
            <TableCell>Product</TableCell>
            <TableCell>Branch</TableCell>
            <TableCell>Wardrobe</TableCell>
            <TableCell>Entitlement</TableCell>
            <TableCell>Remaining</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entitlementLines?.map((line, index) => (
            <TableRow
              key={line.productCode}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell>{line.productCode}</TableCell>
              <TableCell>{line.branchname}</TableCell>
              <TableCell>{line.wardrobename}</TableCell>
              <TableCell>{line.entitledQty}</TableCell>
              <TableCell>{line.remainingQTY}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

// const test = {
//   staffid: "STA122506",
//   branchid: "B001",
//   staffName: "George Pig",
//   productCode: "BMSPDC",
//   wardrobe: "WARDROBE00025",
//   entitledQty: "1",
//   remainingQTY: "1",
//   branchname: "Branch 1 Scotland",
//   wardrobename: "Standard Wardrobe",
// };
